module.exports = __webpack_public_path__ + "img/vertical_4_7_9006.af27f300.png";